import { Reveal, SectionHeading } from "./Section";
import { Globe2 } from "lucide-react";

const REGIONS = [
  { code: "IN", name: "India", focus: "Technology · Entrepreneurship · Government · Infrastructure" },
  { code: "AE", name: "UAE", focus: "Strategic partnerships · Aviation · Technology · Investment" },
  { code: "NP", name: "Nepal", focus: "Aviation pilot operations · TrackSure deployment · Airline partnerships" },
  { code: "GL", name: "Global", focus: "Relationships that create long-term commercial and social value" },
];

const GlobalWork = () => (
  <section id="global" className="relative py-28 md:py-36" data-testid="global-section">
    <div className="mx-auto max-w-7xl px-5 md:px-8">
      <SectionHeading index="06" eyebrow="Global Work" title="Connecting India with the World." subtitle="My work increasingly sits across borders — technology, capital, government, infrastructure and entrepreneurship coming together." />
      <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
        {REGIONS.map((r, i) => (
          <Reveal key={r.code} delay={i * 0.07}>
            <div className="group relative h-full rounded-2xl border border-white/8 bg-[#10141d] p-6 hover:border-[#E9C88A]/40 hover:-translate-y-1.5 hover:shadow-[0_18px_50px_rgba(233,200,138,0.12)] transition-all duration-500" data-testid={`region-${r.code.toLowerCase()}`}>
              <div className="flex items-center justify-between">
                <span className="font-display text-4xl font-semibold text-outline group-hover:text-[#E9C88A] group-hover:[-webkit-text-stroke:0] transition-all duration-500">{r.code}</span>
                <Globe2 size={18} className="text-slate-600 group-hover:text-[#E9C88A] transition-colors" />
              </div>
              <h3 className="mt-5 font-display text-xl font-semibold text-slate-100">{r.name}</h3>
              <p className="mt-2 text-[13px] text-slate-400 leading-relaxed">{r.focus}</p>
            </div>
          </Reveal>
        ))}
      </div>
      <Reveal delay={0.2}>
        <p className="mt-14 text-center font-display italic text-2xl md:text-3xl text-slate-300">“Markets may be separated by borders. <span className="gold-text not-italic font-semibold">Opportunity isn't.</span>”</p>
      </Reveal>
    </div>
  </section>
);

export default GlobalWork;
